import React from 'react'
import { Button, Card, CardActionArea, CardActions, CardContent, Dialog, Typography } from '@mui/material'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'

interface ModalComponentInterface {
  exibir: boolean
  setExibir: React.Dispatch<React.SetStateAction<any>>
}

export default function HelpTeclasLeiura({ exibir, setExibir }: ModalComponentInterface) {

  const Cabecalho: Array<DataTableCabecalhoInterface> = [{
    campo: 'tecla',
    cabecalho: 'Tecla'
  }, {
    campo: 'descricao',
    cabecalho: 'Descrição'
  }]

  const rsDados = [
    {
      'tecla': 'TAB',
      'descricao': 'Ir para a Direita'
    },
    {
      'tecla': 'SHIFT + TAB',
      'descricao': 'Ir para a Esquerda'
    },
    {
      'tecla': 'ALT + C',
      'descricao': 'Copiar célula atual para a coluna inteira'
    },
    {
      'tecla': 'ENTER ou F2',
      'descricao': 'Permite alterar o Campo Atual'
    },
    {
      'tecla': 'ENTER ou ESC',
      'descricao': 'Encerra a edição do Campo Atual'
    },
    {
      'tecla': 'DEL',
      'descricao': 'Apaga Conteudo do Campo Atual'
    },
    {
      'tecla': 'Botão Salvar',
      'descricao': 'Grava os Dados (Obrigatório!)'
    },
    /*
    {
      'tecla': 'ALT + T',
      'descricao': 'Copiar a linha atual para todas as outras'
    },
    {
      'tecla': 'CTRL + ALT + <n>',
      'descricao': 'Copia O CAMPO da linha anterior de número n (1 a 9) para o CAMPO atual'
    },
    {
      'tecla': 'ALT + <n>',
      'descricao': 'Copia O REGISTRO da linha anterior de número n (1 a 9) para o REGISTRO atual'
    },
    {
      'tecla': 'ALT + DEL',
      'descricao': 'Apaga Tudo! Cuidado!'
    },
    */
  ]

  return (
    <>
      <Dialog
        fullWidth
        open={exibir}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onClose={() => setExibir(false)}
      >
        <Card >
          <CardActionArea>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Teclas
              </Typography>
              <DataTable
                dados={rsDados}
                cabecalho={Cabecalho}
                acoes={[]} />
            </CardContent>
          </CardActionArea>
          <CardActions>
            <Button size="small" color="primary" onClick={() => setExibir(false)}>
              Fechar
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  )

}